const ResponsibilityList = ({ list }) => {
  return (
    <div>
      <ul className="flex flex-col gap-3">
        {list?.map((item, index) => (
          <li className="ml-5 list-disc text-sm text-neutral-900" key={index}>
            {item}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default ResponsibilityList;
